import React from 'react';

const Marketing = (props: { className: any, onClick?: any }) => {
  const { className, onClick } = props;



  return (
    <svg width="45" className={className} height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.4118 24.4434V17.0345M23.4118 24.4434L28.592 27.356C28.7351 27.4364 28.8972 27.4785 29.062 27.4779C29.2268 27.4774 29.3886 27.4342 29.5312 27.3528C29.6737 27.2715 29.7921 27.1547 29.8743 27.0141C29.9566 26.8736 29.9999 26.7143 30 26.5521V14.9258C29.9999 14.7636 29.9566 14.6043 29.8743 14.4638C29.7921 14.3233 29.6737 14.2065 29.5312 14.1251C29.3886 14.0437 29.2268 14.0006 29.062 14C28.8972 13.9995 28.7351 14.0415 28.592 14.1219L23.4118 17.0345M23.4118 24.4434H20.5882M23.4118 17.0345H17.7647C16.7662 17.0345 15.8087 17.4248 15.1027 18.1195C14.3966 18.8143 14 19.7565 14 20.739C14 21.7214 14.3966 22.6637 15.1027 23.3584C15.8087 24.0531 16.7662 24.4434 17.7647 24.4434M20.5882 24.4434H17.7647M20.5882 24.4434V26.5271V28.6108C20.5882 28.9793 20.4395 29.3326 20.1747 29.5931C19.91 29.8536 19.5509 30 19.1765 30C18.802 30 18.443 29.8536 18.1782 29.5931C17.9134 29.3326 17.7647 28.9793 17.7647 28.6108V24.4434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> 
  );
};
export default Marketing;

